import { render, staticRenderFns } from "./listTab.vue?vue&type=template&id=21275d35&"
import script from "./listTab.vue?vue&type=script&lang=js&"
export * from "./listTab.vue?vue&type=script&lang=js&"
import style0 from "./listTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports